export const ACTIVATE_FUNCS = {
    NONE: "",
    RELU: "ReLU",
    LEAKY_RELU: "Leaky ReLU",
    SIGMOID: "Sigmoid",
    TANH: "Tanh",
    SOFTMAX: "Softmax",
};